import React from "react";
import useUkm from "../../../services/queries/useUkm";
import useUser from "../../../services/queries/useUser";
import useKategori from "../../../services/queries/useKategori";
import useTimeAlt from "../../../services/queries/useTimeAlt";
import useSelectedUkm from "../../../services/queries/useSelectedUkm";

const initialParamsUkm = {
    size: 500,
    page: 1,
    search: "",
};

export default function useStokBarangPageData(ukmIdFromAuth?: number | string) {
    const { data: user } = useUser();
    const { data: ukm } = useUkm(initialParamsUkm);
    const { data: time } = useTimeAlt();

    const { ukmData, isUkmTidakAktif } = useSelectedUkm(user, ukm, time);

    const noAccessStok = user?.aksesStok === 0 || user?.aksesStok === null;

    const kategoriParams = React.useMemo(
        () => ({
            ukmId:
                !noAccessStok && !isUkmTidakAktif && ukmIdFromAuth
                    ? Number(ukmIdFromAuth)
                    : undefined,
            size: 500,
            page: 1,
            search: "",
        }),
        [isUkmTidakAktif, noAccessStok, ukmIdFromAuth],
    );

    const { refetch: refetchKategori } = useKategori(kategoriParams);

    return {
        isUkmTidakAktif,
        noAccessStok,
        refetchKategori,
        ukmData,
    };
}
